// export const link = "https://api.silgatecrm.com/api/v1/";
export const link = "https://api.therudrix.in/api/v1/";
// export const uploadLink = "https://api.silgatecrm.com/";
export const uploadLink = "https://api.therudrix.in/";
